import React, {FC, useState} from "react";
import {Broadcast, useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const EditBroadcastCoverImageModal: FC<{ broadcast: Broadcast, onFinished: () => void }> = (props) => {
  const { broadcasts } = useApiCall(config)
  const [coverImage, setCoverImage] = useState<File|null>(null)
  const {showToast} = useToasts()

  const submit = async () => {
    if (! coverImage) {
      return
    }
    await broadcasts.updateCoverImage(props.broadcast.id, coverImage).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
    })
    props.onFinished()
  }

  return <div className={'space-y-3'}>
    <div>
      <input type={'file'} onChange={(event) => setCoverImage(event.target.files?.[0] ?? null)} />
    </div>
    {coverImage && <div>
      <div className={'text-sm font-medium text-brand-900 mb-1 mt-4'}>Voorbeeld cover</div>
      <img src={`${URL.createObjectURL(coverImage)}`} alt="" className={'w-full h-64 object-cover rounded-lg'} />

      <div className={'text-sm font-medium text-brand-900 mb-1 mt-4'}>Voorbeeld thumbnail</div>
      <img src={`${URL.createObjectURL(coverImage)}`} alt="" className={'w-64 h-64 object-cover rounded-lg'} />
    </div>}
    <ModalFooter text={'Opslaan'} isDisabled={! coverImage} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}